import {
  FormControl,
  FormHelperText,
  Input,
  InputAdornment,
  MenuItem,
  Select,
} from "@material-ui/core";
import SearchIcon from "@material-ui/icons/Search";
import FilterListIcon from "@material-ui/icons/FilterList";
import HighlightOffIcon from "@material-ui/icons/HighlightOff";
import * as React from "react";

export interface SearchBoxProps {
  doSearch: (value: string) => void;
  doFilter?: (value: string) => void;
  placeHolder: string;
  hasFilter: boolean;
}

export default class SearchBox extends React.Component<SearchBoxProps, any> {
  constructor(props: SearchBoxProps) {
    super(props);
    this.state = {
      searching: false,
      searchValue: "",
      filter: "none",
    };
    this.keyUp = this.keyUp.bind(this);
    this.handleChangeFilter = this.handleChangeFilter.bind(this);
  }

  keyUp(event: React.KeyboardEvent<HTMLInputElement>) {
    if (event.key === "Enter") {
      this.props.doSearch(this.state.searchValue);
      this.setState({ searching: true });
    }
  }

  handleChangeFilter(event: React.ChangeEvent<HTMLSelectElement>) {
    const value = event.target.value;
    this.setState({ filter: value });
    this.props.doFilter!(value);
    if (value === "") {
      this.setState({ filter: "none" });
    }
  }

  getEndAdornment = () => {
    if (this.state.searching) {
      return (
        <InputAdornment
          position="end"
          onClick={() => {
            this.setState({ searching: false, searchValue: "" });
            this.props.doSearch("");
          }}
        >
          <HighlightOffIcon />
        </InputAdornment>
      );
    }
    return <></>;
  };

  render() {
    return (
      <div
        style={{
          display: "flex",
          alignItems: "flex-end",
          justifyContent: "flex-end",
          flex: 1,
        }}
      >
        <FormControl style={{ width: 400 }}>
          <Input
            id="input-with-icon-adornment"
            placeholder={this.props.placeHolder}
            value={this.state.searchValue}
            startAdornment={
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            }
            endAdornment={this.getEndAdornment()}
            onChange={(e) => this.setState({ searchValue: e.target.value })}
            onKeyUp={this.keyUp}
            disabled={this.state.searching}
            onClick={() => {
              this.setState({ searching: false });
            }}
          />
        </FormControl>
        {this.props.hasFilter && (
          <FormControl style={{ marginLeft: 20 }}>
            <Select
              value={this.state.filter}
              onChange={this.handleChangeFilter}
              inputProps={{
                name: "age",
                id: "age-simple",
              }}
            >
              <MenuItem value="none" disabled>
                <FilterListIcon />
              </MenuItem>
              <MenuItem value="ACTIVE">Activos</MenuItem>
              <MenuItem value="INACTIVE">Inactivos</MenuItem>
              <MenuItem value="">Todos</MenuItem>
            </Select>
          </FormControl>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/SearchBox.tsx